export const COLLECTION_NOVELTIES = 'nouveautes';

export enum COLLECTIONS_TAGS {
  FRESH = 'fresh',
  ULTRA_FRESH = 'ultra-fresh',
}
